export function RecoveryPage(){
    return (
        <div>Recovery</div>
    )
}